import { useRef, useState } from 'react';

import { usePoolDispatch } from '../hooks';
import { pausedText, poolStatusText } from '../poolStatus';

import PoolAutoInviteModal from './PoolAutoInviteModal';

import '../../DashboardV2/dashboardV2.css';

type Props = {
  jobId: number | string;
  timezone?: string | null;
  /** Tenant admins only; everyone else gets nothing (and no request). */
  canManage: boolean;
};

/*
 * GRAVY-10898 — the Job page's one line on preferred pool auto-invite, under
 * the auto backups strip: where this job's pool ladder stands, and "View" for
 * the waves, Pause / Resume and the "why pool members were left out" list
 * (PoolAutoInviteModal). Hidden until the read lands, and on an error, so a
 * job of a client that never used pool automation shows no empty strip.
 */
const JobPoolAutoInviteRow = ({ jobId, timezone, canManage }: Props) => {
  const { data } = usePoolDispatch(jobId, canManage);
  const [open, setOpen] = useState(false);
  const openRef = useRef<HTMLButtonElement>(null);

  if (!canManage || !data) return null;
  const paused = pausedText(data, timezone);

  return (
    <div
      className="dashv2-scope dashv2-poolrow"
      data-testid="job-pool-auto-invite"
    >
      <span className="dashv2-poolrow-label">Preferred pool auto-invite:</span>
      <span data-testid="job-pool-auto-invite-status">
        {poolStatusText(data)}
        {paused ? ` · ${paused}` : ''}
      </span>
      <span aria-hidden="true">·</span>
      <button
        ref={openRef}
        type="button"
        className="dashv2-backup-quiet"
        data-testid="pool-auto-invite-open"
        onClick={() => setOpen(true)}
      >
        View
      </button>
      {open && (
        <PoolAutoInviteModal
          jobId={jobId}
          timezone={timezone}
          onClose={() => {
            setOpen(false);
            openRef.current?.focus();
          }}
        />
      )}
    </div>
  );
};

export default JobPoolAutoInviteRow;
